/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search by name or title…" |
*
* @param {Conversations_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_search_placeholder = /** @type {((inputs?: Conversations_Search_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Search_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zoek op naam of titel…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher par nom ou titre…")
	return /** @type {LocalizedString} */ ("Search by name or title…")
});